<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :class="['staff-password-dialog', 'ah-detail-dialog']"
        top="10vh"
        width="500px"
        append-to-body
        :before-close="handleBeforeClose"
        :lock-scroll="false"
    >
        <template slot="title"> 設定密碼 </template>
        <div class="detail-row">
            <div class="detail-block">
                <div style="text-align: center; margin: 20px 0; line-height: 220%;">
                    <div style="font-size: 15pt;">帳號已新增</div>
                    <div style="font-size: 12pt;">是否立即寄送密碼設定信？</div>
                </div>
                <div style="margin-top: 35px; display: flex; flex-direction: column; gap: 10px;">
                    <el-button type="primary" @click="handleYesBtn" :loading="isSendingEmail">是，立即發送密碼信</el-button>
                    <el-button type="" style="margin-left: 0" @click="handleNoBtn">否，之後個別寄送</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'PaymentDetailDialog',
    props: ['visible', 'sno'],
    data() {
        return {
            isSendingEmail: false,
        };
    },
    computed: {
        iniT_FIN() {
            return false;
            //return this.$store.getters['menu/companyInfo'].iniT_FIN;
        },
    },
    methods: {
        handleBeforeClose() {
            this.$emit('close');
        },

        handleYesBtn() {
            this.sendPasswordEmail(this.sno);
        },

        handleNoBtn() {
            this.$emit('close');
        },

        sendPasswordEmail(sno) {
            this.isSendingEmail = true;

            this.$api({
                url: '/StaffManagementPage/SendResetPasswordEmail',
                method: 'post',
                data: { sno },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '認證信已寄出。',
                        type: 'success',
                    });
                    this.$emit('close');
                })
                .finally(() => {
                    this.isSendingEmail = false;
                });
        },
    },
};
</script>
